// export const baseURL = process.env.VUE_APP_BASE_URL;
// export const sockBaseURL = process.env.VUE_APP_SOCkBASE_URL;

export const baseURL = process.env.NODE_ENV === "production" ?(location.href.indexOf('kefu.dev') !== -1 ? 'https://kefu.dev.dyuit.cn/' : 'https://h5.im.casdt.cn/'):'/api/';
export const sockBaseURL = process.env.NODE_ENV === "production" ?(location.href.indexOf('kefu.dev') !== -1 ? 'https://kefu.dev.dyuit.cn' : 'https://h5.im.casdt.cn'):'https://kefu.dev.dyuit.cn';
